webpackJsonp([54],{

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("29bc0694", content, true);

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.content-buttons[data-v-6d458e45]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration/page-template.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"page-template.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.content-buttons[data-v-6d458e45] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealers-projects"},[_c('action-sidebar',{attrs:{"title":"Template","value":true,"width":644},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"selectable":"","name":"template","last-page":_vm.lastPage,"columns":_vm.columns,"rows":_vm.template,"check-all":_vm.checkAll,"selected-value":_vm.selectedValue,"current-page":_vm.currentPage},on:{"on-selected-all":_vm.allIsSelected,"on-search-event":_vm.onSearch,"row-is-selected":_vm.rowIsSelected,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t")])]}}])})],1),_vm._v(" "),_c('v-tab-item',[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"selectable":"","selected-value":_vm.selectedValueAssigned,"check-all":_vm.checkAllDeallocate,"columns":_vm.columns,"rows":_vm.templateAssigned,"current-page":_vm.currentPageDeallocate,"last-page":_vm.lastPageDeallocated},on:{"on-selected-all":_vm.allIsSelectedDeallocate,"on-search-event":_vm.onSearchTemplateDeallocate,"row-is-selected":_vm.rowIsSelectedDeallocate,"on-page":_vm.changePageDeallocate},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t")])]}}])})],1)],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-3 pb-3 content-buttons"},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\tCancelar\n\t\t\t\t"),_c('img',{staticClass:"ml-2",attrs:{"src":(_vm.$imageUrl + "/icon-cancel.svg"),"alt":""}})]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledAssigned(1)},on:{"click":_vm.assignedTemplate}},[_vm._v("\n\t\t\t\tAsignar\n\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"success","disabled":_vm.disabledDeallocated(0)},on:{"click":_vm.deleteTemplate}},[_vm._v("\n\t\t\t\tDesasignar\n\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__ = __webpack_require__(853);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d458e45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__ = __webpack_require__(1072);
function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d458e45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d458e45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function onSearch(value) {
	this.$emit('on-search', value);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dealers-list',
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		rows: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		lastPage: {
			type: Number,
			default: 0
		},
		currentPage: {
			type: Number,
			default: 0
		},
		columns: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		checkAll: {
			type: Boolean,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__ = __webpack_require__(735);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__ = __webpack_require__(745);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1"},[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"name":"dealers","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"selectable":""},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeProject)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__ = __webpack_require__(744);




var assignedTemplate = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var templatesIds;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						templatesIds = this.dataSelected.map(function (action) {
							return action.id;
						});
						_context.prev = 1;
						_context.next = 4;
						return this.$http.post('distributaries/' + this.id + '/templates', { templatesIds: templatesIds });

					case 4:
						this.showNotification('Los templates fueron asignados correctamente.');
						this.closeModal();
						this.listTemplate();
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function assignedTemplate() {
		return _ref.apply(this, arguments);
	};
}();

var deleteTemplate = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var ids, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						ids = this.dataSelectedDeallocate.map(function (item) {
							return item.id;
						});
						body = {
							templatesIds: ids
						};
						_context2.prev = 2;
						_context2.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/templates', { data: body });

					case 5:
						this.showNotification('Template eliminado correctamente');
						this.closeModal();
						this.listTemplateDeallocated();
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 10]]);
	}));

	return function deleteTemplate() {
		return _ref2.apply(this, arguments);
	};
}();

var listTemplate = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 30,
							isSelected: 0
						};
						_context3.prev = 1;
						_context3.next = 4;
						return this.$http.get('distributaries/' + this.id + '/templates', { params: params });

					case 4:
						response = _context3.sent;

						this.template = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context3.next = 12;
						break;

					case 9:
						_context3.prev = 9;
						_context3.t0 = _context3['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[1, 9]]);
	}));

	return function listTemplate() {
		return _ref3.apply(this, arguments);
	};
}();

var listTemplateDeallocated = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 30,
							isSelected: 1
						};
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.get('distributaries/' + this.id + '/templates', { params: params });

					case 4:
						response = _context4.sent;

						this.templateAssigned = response.data.data;
						this.lastPageDeallocated = Number(response.headers['x-last-page']);
						_context4.next = 12;
						break;

					case 9:
						_context4.prev = 9;
						_context4.t0 = _context4['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 9]]);
	}));

	return function listTemplateDeallocated() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function disabledAssigned(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocate.length < 1;
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listTemplate();
}

function changePageDeallocate(page) {
	this.params.page = page;
	this.currentPageDeallocate = page;
	this.listTemplateDeallocated();
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function rowIsSelectedDeallocate(row) {
	this.templateAssigned = this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, row);
	this.dataSelectedDeallocate = this.templateAssigned.filter(function (r) {
		return r.flag;
	});
	this.checkAllDeallocate = this.every(this.templateAssigned, this.selectedValueAssigned);
}

function rowIsSelected(row) {
	this.template = this.selectIsRow(this.template, this.selectedValue, row);
	this.dataSelected = this.template.filter(function (r) {
		return r.flagSelected;
	});
	this.checkAll = this.every(this.template, this.selectedValue);
}

function created() {
	this.listTemplate();
	this.listTemplateDeallocated();
}

function onSearchTemplateDeallocate(value) {
	this.params.search = value ? value.trim() : null;
	this.listTemplateDeallocated();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.listTemplate();
}

function allIsSelectedDeallocate(checked) {
	var _this = this;

	this.checkAllDeallocate = checked;
	this.dataSelectedDeallocate = [];
	this.templateAssigned = this.templateAssigned.map(function (element) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRow.isSelected = checked;
		if (checked) {
			_this.dataSelectedDeallocate.push(element);
		}
		return newRow;
	});
	this.templateAssigned = this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, false, checked);
}

function allIsSelected(checked) {
	var _this2 = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.template = this.template.map(function (item) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		newRow.isSelected = checked;
		if (checked) {
			_this2.dataSelected.push(item);
		}
		return newRow;
	});
	this.template = this.selectIsRow(this.template, this.selectedValue, false, checked);
}

function data() {
	return {
		checkAllDeallocate: false,
		checkAll: false,
		currentPage: 1,
		currentPageDeallocate: 1,
		dataSelected: [],
		dataSelectedDeallocate: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		selectedValueAssigned: 'flag',
		selectedValue: 'flagSelected',
		template: [],
		templateAssigned: [],
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Descripción', value: 'description', checked: true, visible: true }],
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}],
		tabsModel: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-template',
	data: data,
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"],
		tableAssign: __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__["a" /* default */]
	},
	methods: {
		allIsSelected: allIsSelected,
		allIsSelectedDeallocate: allIsSelectedDeallocate,
		assignedTemplate: assignedTemplate,
		changePage: changePage,
		changePageDeallocate: changePageDeallocate,
		closeModal: closeModal,
		deleteTemplate: deleteTemplate,
		disabledAssigned: disabledAssigned,
		disabledDeallocated: disabledDeallocated,
		listTemplate: listTemplate,
		listTemplateDeallocated: listTemplateDeallocated,
		rowIsSelectedDeallocate: rowIsSelectedDeallocate,
		onSearchTemplateDeallocate: onSearchTemplateDeallocate,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		id: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/54.6d225ac6aa1ed251325d.js